export default __webpack_public_path__ + "static/media/speech-bubble.bdc46cfd.svg";